<template>
    <master-page v-if="!loading">
        <sub-menu></sub-menu>
        <div class="flex flex-col space-x-6 xl:justify-center xl:flex-row px-4 py-8">
            <article class="w-full mt-8 xl:mt-0">
                <section v-if="post" class="container-1024 m-auto ">
                    <h1 class="text-gray-500 text-center text-4xl font-bold pb-10">{{ post.title }}</h1>
                    <area-category></area-category>

                    <div class="mx-auto container-1024">
                        <div>
                            <Gallery
                                :medias="post.medias"
                                containerClasses="w-full p-3"
                                imageContainerClasses="w-full"
                                :showThumbs="true"
                            />
                            <div v-html="post.text" class="text-justify break-words text-gray-800 p-3"></div>
                        </div>
                        <section class="py-2 md:px-3" v-if="post.files_list.length > 0">
                            <h1 class="text-2xl pb-2 font-bold text-gray-500">
                                Download
                            </h1>
                            <div class="bg-gray-100 p-3 border rounded">
                                <list-component
                                    :items="post.files_list"
                                    :style="filesStyle"
                                />
                            </div>
                        </section>
                    </div>
                </section>
                <section v-else class="container-1024 m-auto ">
                    <h1 class="text-gray-500 text-left text-2xl font-bold pb-4">Nehum conteúdo disponível para exibição</h1>
                    <div class="mx-auto container-1024">
                        <div class="flex items-center p-1">
                                <a @click.stop.prevent="$router.go(-1)" title="Voltar" class="cursor-pointer text-brand hover:text-blue-500 text-3xl mr-2">
                                    <i class="far fa-arrow-alt-circle-left"></i>
                                </a>
                                <small>Voltar para página anterior.</small>
                        </div>

                        <hr class=" border-1 border-gray-300 m-auto">
                    </div>
                </section>
            </article>
        </div>
    </master-page>

</template>

<script>
import { reactive } from 'vue'
import { useRoute } from 'vue-router'
import api from '@/services'

import MasterPage from '@/views/MasterPage'
import SubMenu from '@/views/Page/SubMenu.vue'
import AreaCategory from '@/views/Page/AreaCategory.vue'
import Gallery from '@/components/gallery'
import ListComponent from '@/components/list'

export default {

    name: 'Page',

    components: {
        MasterPage,
        SubMenu,
        AreaCategory,
        Gallery,
        ListComponent
    },

    setup () {
        const route = useRoute()

        const state = reactive({
            post: null,
            comments: [],
            loading: true,
            filesStyle: {
                ul: 'list-decimal ml-4',
                li: 'hover:underline hover:text-brand',
                img: '',
                h2: '',
                span: '',
                abstract: ''
            }
        })

        api.post.getIndexPage(route.params.slug).then( data =>
            {
                if( data.count > 0){
                    var obj = data.collection[0]
                    obj.medias = obj.images_list
                    state.post = obj
                }
                state.loading = !state.loading
            }
        )

        return state
    }
}
</script>

<style lang="css" scoped>
</style>